import { useEffect, useState } from 'react';
import { useAuth } from './useAuth';
import { toast } from 'sonner';

export const useSessionTimeout = () => {
  const { session, refreshSession } = useAuth();
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    if (!session) return;

    const checkSessionExpiry = () => {
      if (!session.expires_at) return;

      const now = Date.now() / 1000;
      const expiresAt = session.expires_at;
      const timeUntilExpiry = expiresAt - now;

      // Show warning 5 minutes (300 seconds) before expiry
      if (timeUntilExpiry <= 300 && timeUntilExpiry > 0 && !showWarning) {
        setShowWarning(true);
        const minutes = Math.floor(timeUntilExpiry / 60);
        toast.warning(
          `Your session will expire in ${minutes} minute${minutes !== 1 ? 's' : ''}`,
          {
            duration: 10000,
            action: {
              label: 'Extend Session',
              onClick: async () => {
                await refreshSession();
                setShowWarning(false);
                toast.success('Session extended successfully');
              },
            },
          }
        );
      }
    };

    // Check immediately
    checkSessionExpiry();

    // Check every minute
    const interval = setInterval(checkSessionExpiry, 60000);

    return () => clearInterval(interval);
  }, [session, refreshSession, showWarning]);

  return { showWarning };
};
